import React, { Component } from 'react'
import PropTypes from 'prop-types'


class IntersectionSubscriber extends Component {

  static propTypes = {
    onceIntersect: PropTypes.func, // trigger once then unsubscribe automatically
    onIntersect: PropTypes.func, // trigger on each intersect, pay attention that there is second param "unsibscribe" passing to onIntersect
  }

  static contextTypes = {
    intersectionObserver: PropTypes.shape({
      subscribe: PropTypes.func,
      unsubscribe: PropTypes.func,
    }),
  }

  constructor({ children }) {
    super()

    this.isStatelessChildren = (
      !Array.isArray(children)
      && children.type.prototype
      && !children.type.prototype.render
    )

    if (this.isStatelessChildren) {
      this.ref = React.createRef()
    }
    else {
      this.node = null
    }
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  componentDidMount() {
    if (this.isStatelessChildren && this.ref.current) {
      this.setNode(this.ref.current)
    }

    if (this.node) {
      this.subscribe()
    }
    else {
      console.error('node is not defined')
    }
  }

  setNode = (node) => {
    const { children } = this.props

    this.node = node

    if (typeof children.ref === 'function') {
      children.ref(node)
    }
  }

  subscribe() {
    const { intersectionObserver: { subscribe } = {} } = this.context

    if (typeof subscribe !== 'function') {
      throw new TypeError('Expected IntersectionSubscriber to be mounted within IntersectionObserverConductor')
    }

    subscribe({
      node: this.node,
      handler: this.handleIntersection,
    })
  }

  unsubscribe = () => {
    const { intersectionObserver: { unsubscribe } } = this.context

    unsubscribe({
      node: this.node,
      handler: this.handleIntersection,
    })
  }

  /**
   *
   * @param {Object} entry
   * @param {Object} entry.boundingClientRect
   * @param {number} entry.intersectionRatio
   * @param {Object} entry.intersectionRect
   * @param {Boolean} entry.isIntersecting
   * @param {Object} entry.rootBounds
   * @param {node} entry.target
   * @param {number} entry.time
   */
  handleIntersection = (entry) => {
    const { onceIntersect, onIntersect } = this.props

    if (typeof onceIntersect === 'function') {
      if (entry.isIntersecting) {
        this.unsubscribe()
        onceIntersect(entry)
      }
    }
    else if (typeof onIntersect === 'function') {
      onIntersect(entry, this.unsubscribe)
    }
  }

  render() {
    const { children } = this.props

    return React.cloneElement(React.Children.only(children), {
      ref: this.isStatelessChildren ? this.ref : this.setNode,
    })
  }
}


export default IntersectionSubscriber
